import styled from "styled-components"

export const TypeWrapper = styled.div`
margin-bottom: 2rem;
`
